var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromotionalCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#FFF6E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.0584 49.9484C71.8807 49.9484 78.3889 51.2674 78.3889 57.8622C78.3889 64.4571 71.8807 65.776 70.0584 65.776M70.0584 36.7588L53.3973 48.4829C36.7363 48.4829 36.7363 47.3105 36.7363 59.1812C36.7363 59.1812 36.7363 59.1812 36.7363 59.1812C36.7363 59.1812 36.7363 62.1504 36.7363 65.2414C36.7363 66.346 37.6318 67.2415 38.7363 67.2415H53.3973C59.9039 71.8201 70.0584 78.9657 70.0584 78.9657V36.7588Z",
    stroke: "#FF739D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3548 81.3769V67.5493H44.5449V81.3769C44.5449 82.4815 45.4404 83.3769 46.5449 83.3769H50.3548C51.4593 83.3769 52.3548 82.4815 52.3548 81.3769Z",
    stroke: "#FF739D",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4036 57.8623H83.5938",
    stroke: "#FF739D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5146 42.035L80.9922 47.6309",
    stroke: "#FF739D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5146 74.0095L80.9922 68.4136",
    stroke: "#FF739D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3555 68.4138V49.9482",
    stroke: "#FF739D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionalCopy);
export default __webpack_public_path__ + "static/media/promotional-copy.b5610456.svg";
export { ForwardRef as ReactComponent };